<div class="dialog-form">
    <iframe [src]="path" frameborder="0" width="100%" height="900"> </iframe> 
</div>